import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import BasicInformation from './steps/BasicInformation';

const RegistrationWizard = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    // Basic Account Setup - Only essential fields
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: ''
  });
  
  const { register } = useAuth();
  const navigate = useNavigate();


  const updateFormData = (newData) => {
    setFormData(prev => ({ ...prev, ...newData }));
  };

  const handleSubmit = async () => {
    try {
      setError('');
      setLoading(true);
      
      // Prepare basic registration data
      const registrationData = {
        email: formData.email,
        password: formData.password,
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formData.phone,
        userType: 'jobseeker'
      };
      
      // Use the register function with basic data
      const name = `${formData.firstName} ${formData.lastName}`;
      await register(formData.email, formData.password, name, 'jobseeker', formData.phone, registrationData);
      
      // Navigate to home page after successful registration
      navigate('/');
    } catch (err) {
      console.error('Registration error:', err);
      setError('Failed to create account. ' + (err.message || ''));
    } finally {
      setLoading(false);
    }
  };

  const getStepContent = () => {
    return (
      <BasicInformation
        formData={formData}
        updateFormData={updateFormData}
        onSubmit={handleSubmit}
        loading={loading}
        error={error}
      />
    );
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box textAlign="center" mb={3}>
          <Typography variant="h4" component="h1" gutterBottom>
            Join Our Platform
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Complete your registration to access all features
          </Typography>
        </Box>

        {getStepContent()}
      </Paper>
    </Container>
  );
};

export default RegistrationWizard;